<!--
  SettleTab.vue
  콜봇 월 정산 · 병원 상세 `정산` 탭(?tab=settle, 기본 탭) — 화면 명세 2-3 · 2-4 를 목업 Detail.dc.html 모양으로.

  두 단(넓으면 왼쪽 본문 + 오른쪽 곁, 좁으면 위아래로 쌓이고 곁이 먼저 온다 — 탭 너비 기준 container query).
  본문
  (a) StatementPanel — 마감 상태 패널(검토 필요면 '확정 전에 볼 것 n건', 추정 중이면 예정 시각과 미리보기, 확정이면 확정 ·
      시각 · 누가 + 수납 상태, 마감 중 · 마감 실패 · v70 이전 · 모르는 상태)
  (b) StatementSheet — '정산서' 표(항목 | 사용량 | 단가 | 금액, 항목마다 계산 근거를 늘 아래에, 검토 필요면 항목마다 '고치기')
  (c) CostBreakdownTable — 늘 펼친 '원가 · 마진' 표(항목을 줄이지 않는다)
  (d) OneOffItems — 일회성 항목(요청 계약 4-4)
  (e) StatementHistory — 마감 이력(접지 않는다)
  곁
  - InboundPoolGauge — 포함 120분 카드
  - StatementConfirmCard — 검토 필요면 '이 달 확정'(경고 확인 체크 · 저장 메모 · 저장 · 다시 계산 · '{합계}원으로 확정'),
    확정이면 [재수정]

  정산 대상 아닌 달(정산 시작일 전 — notBillableView): 패널이 빈 상태 카드(+ [시작일 바꾸기] · 남은 정산서면 [남은 정산서
  지우기]/[재수정])가 되고, 정산서 표·확정 카드는 그리지 않는다([재수정]은 빈 상태 카드에만 하나). 원가 표·일회성 항목
  (지우기만)·마감 이력·포함 120분 카드는 그대로 그린다.

  검토 상태(항목 금액 입력·경고 확인·저장·다시 계산·확정 흐름)는 useStatementReview 하나가 들고 패널·표·카드에 나눠 준다
  (예전 StatementReviewForm 의 일).

  데이터
  - 셸이 받은 정산 상세(`detail`)를 그대로 나눠 준다. 탭을 바꿀 때 다시 부르지 않는다.
  - 이 탭이 따로 부르는 것은 일회성 항목 목록 하나(OneOffItems 가 마운트할 때 한 번 + 자기 쓰기 뒤).
  - 쓰기(저장·다시 계산·확정, 마감 다시 실행, 일회성 항목) 뒤에는 언제나 reload() 로 상세를 다시 부른다 — 헤더와 이 탭이
    함께 바뀐다.

  셸 ↔ 탭 계약(네 탭 공통, SettlementDetail.vue)
  - props: companyId · month · detail · detailLoading · api · mock · reload · intent
  - emits: 'go-tab'(tab, intent?) · 'open-reopen'(재수정 모달은 셸이 들고 있다) · 'open-start'({ cleanup })(시작일 모달도 셸) ·
           'intent-done'
  - intent: focus-recalculate(요율 탭 예외 저장·대사 뒤 → 검토 필요면 [다시 계산]으로 — 곁 카드에 있으면 카드, 목록 앞
            버튼·v70 이전 줄에 있으면 패널 — 아니면 패널에 이유 한 줄)
            focus-warnings(대사 탭 → 마감 상태 패널로). 상세가 다 오면 옮기고 intent-done 을 보낸다.
  요청: ~/md/front/admin-콜봇-월정산-프론트요청.md "화면 명세 2 › 정산 탭", "요청 계약 4"
-->
<template>
  <div class="settle-tab">
    <a-spin :spinning="detailLoading" :delay="150" tip="정산 상세를 다시 불러오는 중">
      <div class="settle-tab__grid">
        <div class="settle-tab__main">
          <StatementPanel
            ref="panelRef"
            :company-id="companyId"
            :month="month"
            :detail="detail"
            :api="api"
            :reload="reload"
            :review="review"
            @go-tab="onGoTab"
            @focus-line="onFocusLine"
            @recalculate="onRecalculate"
            @acknowledge="onAcknowledge"
            @open-start="(opts) => emit('open-start', opts)"
            @open-reopen="emit('open-reopen')"
          />
          <StatementSheet
            v-if="!notBillable.notBillable"
            ref="sheetRef"
            :detail="detail"
            :month="month"
            :review="review"
            :summary="summary"
          />
          <CostBreakdownTable :detail="detail" :month="month" :summary="summary" :live="live" />
          <!-- 일회성 항목 목록은 이 탭이 마운트될 때 한 번만 부른다 -->
          <OneOffItems :company-id="companyId" :month="month" :detail="detail" :api="api" :reload="reload" />
          <StatementHistory :statement="detail.statement ?? null" />
        </div>

        <aside class="settle-tab__aside" aria-label="포함 통화와 확정">
          <InboundPoolGauge :detail="detail" />
          <StatementConfirmCard
            v-if="showConfirmCard"
            ref="confirmRef"
            :review="review"
            :detail="detail"
            :status="status"
            @open-reopen="emit('open-reopen')"
          />
        </aside>
      </div>
    </a-spin>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue';

import CostBreakdownTable from './CostBreakdownTable.vue';
import InboundPoolGauge from './InboundPoolGauge.vue';
import OneOffItems from './OneOffItems.vue';
import StatementConfirmCard from './StatementConfirmCard.vue';
import StatementHistory from './StatementHistory.vue';
import StatementPanel from './StatementPanel.vue';
import StatementSheet from './StatementSheet.vue';
import { useStatementReview } from './useStatementReview';
import { statementStatusOf, summaryLine } from '../../service/settlementRules';
import { notBillableView } from '../../service/settlementStart';

const props = defineProps({
  companyId: { type: String, required: true },
  /** 'YYYY-MM'(KST) */
  month: { type: String, required: true },
  /** 정산 상세(요청 계약 2) — 셸이 첫 상세를 받은 뒤에만 이 탭을 마운트한다 */
  detail: { type: Object, required: true },
  detailLoading: { type: Boolean, default: false },
  /** settlementApi 또는 같은 모양의 목(getSettlementApi()) */
  api: { type: Object, required: true },
  /** 목 데이터(?settlementMock=1) — 이 탭은 목 전용 조작이 없다(마감 상태 고르기는 셸 헤더) */
  mock: { type: Boolean, default: false },
  /** 정산 상세를 다시 부른다 — 쓰기 뒤마다 */
  reload: { type: Function, required: true },
  /** 셸이 이 탭에 보낸 지시 { type, payload?, nonce } — 'focus-recalculate' | 'focus-warnings' */
  intent: { type: Object, default: null },
});

const emit = defineEmits(['go-tab', 'open-reopen', 'open-start', 'intent-done']);

const panelRef = ref(null);
const sheetRef = ref(null);
const confirmRef = ref(null);

const review = useStatementReview(props, { focusChecklist: () => confirmRef.value?.focusChecklist() });

const status = computed(() => statementStatusOf(props.detail));
const summary = computed(() => summaryLine(props.detail));
/**
 * 정산 시작일 전 달 — 정산서 표·확정 카드를 숨긴다. 남은 확정 정산서의 [재수정]은 패널의 빈 상태 카드에 하나만 둔다
 * (확정 카드에도 두면 같은 버튼이 두 번 보인다)
 */
const notBillable = computed(() => notBillableView(props.detail));
const showConfirmCard = computed(() => {
  if (status.value !== 'review' && status.value !== 'confirmed') return false;
  return !notBillable.value.notBillable;
});
/** Margin from the amounts being typed (review, unsaved) — the cost details follow the statement table */
const live = computed(() => {
  const t = review.totals.value;
  if (!review.editable.value || !review.dirty.value || !t) return null;
  return { supply: t.total, margin: review.margin.value };
});

function onGoTab(tab, intent) {
  emit('go-tab', tab, intent);
}

/** Resolution '… 금액 고치기' — open that item in the statement table */
function onFocusLine(key) {
  sheetRef.value?.focusLine(key);
}

/** Resolution [다시 계산] (panel) — run it; when the aside card also has the button, show it there */
function onRecalculate() {
  confirmRef.value?.focusRecalculate();
  review.recalculate();
}

/** Resolution "그대로 확정(경고 확인)" — tick the aside checkbox */
function onAcknowledge(code) {
  review.acknowledge(code);
  confirmRef.value?.focusChecklist();
}

// ---------------------------------------------------------------------------
// 셸 intent — 다시 받는 중이면 다 온 뒤에, 마운트된 뒤에 옮긴다
// ---------------------------------------------------------------------------

const FOCUS_INTENTS = new Set(['focus-recalculate', 'focus-warnings']);
let isMounted = false;
let pending = null;

async function runPendingIntent() {
  const intent = pending;
  if (!intent || !isMounted) return;
  if (FOCUS_INTENTS.has(intent.type) && props.detailLoading) return;
  pending = null;
  if (FOCUS_INTENTS.has(intent.type)) {
    // KeepAlive 로 다시 붙는 중일 수 있다 — DOM 이 들어간 뒤에 스크롤한다
    await nextTick();
    if (intent.type === 'focus-recalculate') {
      // [다시 계산] lives on the aside card, or — when a todo item / the legacy line already offers it — in the panel
      if (notBillable.value.notBillable) {
        // 정산 대상 아닌 달은 [다시 계산]이 없다 — 패널이 이유 한 줄
        await panelRef.value?.showRecalcNote();
      } else if (status.value === 'review') {
        if (!confirmRef.value?.focusRecalculate()) await panelRef.value?.focusRecalculate();
      } else {
        await panelRef.value?.showRecalcNote();
      }
    } else {
      await panelRef.value?.focusWarnings();
    }
  }
  // 이 탭이 모르는 지시·옮길 수 없는 지시도 받기만 한다(셸이 지시를 비우게)
  emit('intent-done');
}

watch(
  () => props.intent?.nonce,
  (nonce) => {
    if (nonce === undefined || nonce === null || !props.intent) return;
    pending = props.intent;
    runPendingIntent();
  },
  { immediate: true }
);

watch(
  () => [props.detail, props.detailLoading],
  () => runPendingIntent()
);

onMounted(() => {
  isMounted = true;
  runPendingIntent();
});
</script>

<style scoped lang="scss">
@use '../../styles/settlement' as *;

.settle-tab {
  min-width: 0;
  // Light gray ground under the white cards (mockup page background) — fills the shell card's padding below the tab bar
  margin: -12px -16px -16px;
  padding: 20px 16px 16px;
  border-radius: 0 0 12px 12px;
  background: #f4f5f7;
  // Width of the tab itself decides the stacking below (the side nav makes the viewport width unreliable)
  container-type: inline-size;

  // Two columns that stack on narrow widths (mockup: main 640px+, aside 340px+)
  &__grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 20px;
  }

  &__main {
    display: flex;
    flex: 999 1 640px;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
  }

  &__aside {
    display: flex;
    flex: 1 1 320px;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
  }
}

// Stacked (main 640 + gap 20 + aside 320 no longer fit): the gauge and the confirm card come first, next to the review
// list that asks for them, instead of after the statement, costs, one-off items and history
@container (max-width: 979px) {
  .settle-tab__aside {
    order: -1;
  }
}
</style>
